import {pdsHttpUtils} from '../pds-http-utils';
import { Observable } from 'rxjs';
import { UserType, NavigationLinkRI } from 'common-utils/rest-interfaces';
import { pdsLocalStorage } from '../pds-local-storage';
import {map} from 'rxjs/operators';

const helpLinkRequestUrl = '/navigation/v1/navigationlink';
export class HelpLinkService {

    getNavLinks(districtUID: string, userType: UserType, navGroup: string | Array<string>, hostUrl: string): Observable<Array<NavigationLinkRI>> {
        let requestURL = hostUrl + helpLinkRequestUrl;
        if (typeof navGroup === 'string') {
            navGroup = [navGroup];
        }
        let queryParam = {
            'navigationGroups': navGroup.join(','),
            'userType': userType,
            'districtUid': districtUID
        };
        let headers = {
            'content-type': 'application/json',
            Authorization: `Bearer ${pdsLocalStorage.getItem('auth_token')}`
        };
        return pdsHttpUtils.get(requestURL, queryParam, headers).pipe(map((ajaxResponse: any) => {
          return <Array<NavigationLinkRI>>JSON.parse(ajaxResponse.data);
        }));
    }
}
